export default {
  proveedores: [],
  proveedoresActivos: [],
  selectedProveedor: null,
  error: false,
  errorMessage: [],
}
